import { autoinject, Aurelia, transient } from 'aurelia-framework';
import { HttpClient, HttpResponseMessage, HttpRequestMessage } from 'aurelia-http-client';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import * as AppMessage from '../models/app-message';
import { AppMessageContainer } from '../services/app-message-container';

@transient()
@autoinject()
export class AppMessageService {

    events = {
        message_added: "app-message-added",
        message_deleted: "app-message-deleted",
        messages_changed: "app-message-changed"
    };

    constructor(private ea: EventAggregator, private msgContainer: AppMessageContainer) {
        ea.subscribe("router:navigation:processing", () => {
            this.clearPageScopedMessages();
        });
    }


    containerId: string = "root";

    addMessage(message: string, type: AppMessage.MessageType): number;
    addMessage(message: string, type: AppMessage.MessageType, lifetime: AppMessage.MessageLifetime, key?: string, isHtml?: boolean): number;
    addMessage(message: AppMessage.Message): number;
    addMessage(param1: any, type: any = null, lifetime: any = null, key: any = null, isHtml = false): number {
        let message: AppMessage.Message;

        if (typeof param1 == "string") {
            message = new AppMessage.Message();
            message.isHtml = isHtml;
            message.content = param1;
            if (type || type === 0) message.type = type;
            if (lifetime || lifetime === 0) message.lifetime = lifetime;

            if (key) message.key = key;

        } else {
            message = param1;
        }

        //ensure there is a key set
        message.key = key || message.content;

        ////subsribe to event if provided
        //if (message.closeOnEvent) {
        //    this.ea.subscribe(message.closeOnEvent, () => this.removeMessage(message.messageId));
        //}

        //TODO: display messages in a dialog if a dialog was open when message was called.

        // timer notifications are always displayed application-wide (scope is ignored)

        if (message.lifetime == AppMessage.MessageLifetime.timer) {
            $["notify"](message.content, { className: "success", position: "top center" });
            return -1;
        } else {

            //check to make sure key doesn't already exist
            if (!message.key || (message.key && !this.msgContainer.messages.find(m => m.key == message.key))) {

                //not sure this is the best place, but for now, set the message's containerId here.
                //  this will control where the message appears, according to the containerId 
                //  that is set on the app - message - bar element
                message.containerId = this.containerId;

                this.msgContainer.messages.push(message)
                this.ea.publish(this.events.message_added, alert);
                this.ea.publish(this.events.messages_changed);
                return message.messageId;
            }
        }
    }

    addInfoMessage(message: string, key?: string) {
        return this.addMessage(message, AppMessage.MessageType.info, AppMessage.MessageLifetime.untilDismissed, key);
    }
    addWarningMessage(message: string, key?: string) {
        return this.addMessage(message, AppMessage.MessageType.warning, AppMessage.MessageLifetime.untilDismissed, key);
    }
    showInfoMessage(message: string, show: boolean, isHtml?: boolean) {
        if (show)
            this.addMessage(message, AppMessage.MessageType.info, AppMessage.MessageLifetime.untilDismissed, message, isHtml);
        else
            this.removeMessageByKey(message);
    }
    showWarningMessage(message: string, show: boolean) {
        if (show)
            this.addMessage(message, AppMessage.MessageType.warning, AppMessage.MessageLifetime.untilDismissed, message);
        else
            this.removeMessageByKey(message);
    }

    addSuccessMessage(message: string) {
        //future-proof in case need to change how "success" messages are displayed.
        return this.addMessage(message, AppMessage.MessageType.success, AppMessage.MessageLifetime.timer);
    }
    addErrorMessage(message: string, lifetime: AppMessage.MessageLifetime, closeOnEvent?: string, key?: any);
    addErrorMessage(message: string, key?: any);
    addErrorMessage(message: string, param1: any, param2?: any) {
        var key, lifetime;
        if (arguments.length == 2) {
            key = arguments[1];
        }
        else if (arguments.length == 3) {
            lifetime = arguments[1];
            key = arguments[2];
        }
        var msg = new AppMessage.Message();
        msg.content = message;
        msg.type = AppMessage.MessageType.error;
        if (lifetime || lifetime === 0) msg.lifetime = lifetime;
        else msg.lifetime = AppMessage.MessageLifetime.untilDismissed;
        msg.key = key;
        var val = this.addMessage(msg);
        //scroll to top of page to ensure error is visible
        window.scrollTo(0, 0);
        return val;
    }

    //clear all messages that are not permanent
    clearNonPersistentMessages() {
        this.removeMessages(m => m.lifetime == AppMessage.MessageLifetime.untilDismissed);
    }

    //clear all messages that are scoped to the page
    clearPageScopedMessages() {
        this.removeMessages(m => m.scope == AppMessage.MessageScope.page);
    }

    removeMessages(callback: (message: AppMessage.Message) => {}) {
        var i = this.msgContainer.messages.length
        var deletedAny = false;
        while (i--) {
            let item = this.msgContainer.messages[i]
            if (callback(item)) {
                this.msgContainer.messages.splice(i, 1);
                this.ea.publish(this.events.message_deleted, item);
                deletedAny = true;
            }
        }
        if (deletedAny) this.ea.publish(this.events.messages_changed);
    }

    removeMessage(messageId) {
        let msg = this.msgContainer.messages.find(m => m.messageId == messageId);
        if (msg) {
            let index = this.msgContainer.messages.indexOf(msg);
            if (index > -1) {
                this.msgContainer.messages.splice(index, 1);
            }
        }
    }

    removeMessageByKey(key: string) {
        let msg = this.msgContainer.messages.find(m => m.key == key);
        if (msg) {
            let index = this.msgContainer.messages.indexOf(msg);
            if (index > -1) {
                this.msgContainer.messages.splice(index, 1);
            }
        }
    }


    handleHttpResponse(response: HttpResponseMessage) {
        if (response.headers.has("Set-App-Message")) {
            var messagesJson = response.headers.get("Set-App-Message");
            var messages = JSON.parse(messagesJson);
            messages.forEach((msg) => this.addMessage(msg));
        }
    }
}